const inputs = {
  oldPassword: {
    id: 'oldPassword',
    name: 'oldPassword',
    input: 'textField',
    type: 'password',
    label: 'changePassword.form.oldPassword',
    placeholder: 'changePassword.form.oldPassword',
    rules: {
      required: { value: true },
    },
  },
  newPassword: {
    id: 'newPassword',
    name: 'newPassword',
    input: 'textField',
    type: 'password',
    label: 'changePassword.form.newPassword',
    placeholder: 'changePassword.form.newPassword',
    rules: {
      required: { value: true },
    },
  },
  confirmPassword: {
    id: 'confirmPassword',
    name: 'confirmPassword',
    input: 'textField',
    type: 'password',
    label: 'changePassword.form.confirmPassword',
    placeholder: 'changePassword.form.confirmPassword',
    rules: {
      required: { value: true },
    },
  },
}
export default inputs;
